import { render } from "./MasterDataColumns.vue?vue&type=template&id=3d90d2bb&scoped=true&ts=true"
import script from "./MasterDataColumns.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumns.vue?vue&type=script&lang=ts"

import "./MasterDataColumns.vue?vue&type=style&index=0&id=3d90d2bb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d90d2bb"]])

export default __exports__